import { FallbackWithParams } from '../common/fallback-with-params';

export const LegacyRouter = () => {
  console.log('legacy router');
  return <FallbackWithParams></FallbackWithParams>;
};
